var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action } from 'mobx';
import { api } from 'helpers/Api';
import { ReceiptLayout } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.set = function (values) {
            _this.data = values.map(function (item) { return new ReceiptLayout(item); });
            _this.loaded = true;
        };
        this.push = function (value) {
            _this.data.push(new ReceiptLayout(value));
        };
        this.replace = function (value) {
            _this.data.splice(_this.data.findIndex(function (f) { return f.id === value.id; }), 1, value);
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('ReceiptLayouts/Store - read')
        if (id)
            return api.get('receiptlayouts' + id);
        return api.get('receiptlayouts').then(function (value) {
            // console.log('receiptLayouts', value)
            _this.set(value);
            return value;
        });
    };
    default_1.prototype.create = function (value) {
        return api.post('receiptlayouts', value).then(this.push);
    };
    default_1.prototype.update = function (id, value) {
        return api.put('receiptlayouts/' + id, value).then(this.replace);
    };
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/ReceiptLayouts/Store.ts
// module id = 710
// module chunks = 0